import {
	BaseQueryFn,
	createApi,
	FetchArgs,
	fetchBaseQuery,
	FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { store } from "./store";
import { clearCourse, resetUserState } from "./userSlice";

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
	args,
	api,
	extraOptions
) => {
	const state = store.getState() as any;
	const baseQueryArgs: FetchBaseQueryArgs = {
		baseUrl: state.site.aspUrl,
		credentials: "include",
		mode: "cors",
		prepareHeaders(headers: Headers) {
			headers.set("Accept", "application/json;profile=camelCase");
			headers.set("X-Requested-With", "XMLHttpRequest");
			headers.set("X-Application", "MIWriteSpa");
			return headers;
		},
	};

	const baseQuery = fetchBaseQuery(baseQueryArgs);
	let result = await baseQuery(args, api, extraOptions);
	if (result.error) {
		if (result.error.status === 401) {
			api.dispatch(resetUserState());
		}
		if (result.error.status === 403) {
			api.dispatch(clearCourse());
		}
	}
	return result;
};

export const siteApiSlice = createApi({
	reducerPath: "siteApi",
	baseQuery: baseQueryWithAuth,
	tagTypes: [
		"CurrentCourse",
		"CurrentSchool",
		"CurrentDistrict",
		"CourseRegistrations",
		"ManageCourse",
		"Alerts",
		"Notifications",
		"ScoreReport",
		"WritingHistory",
		"PeerReview",
		"PeerReviewGroup",
		"LessonHistory",
		"FeedbackComment",
		"Prompts",
		"Schools",
		"School",
	],
	endpoints: () => ({}),
});
